import type { AppointmentResponse, CalendarEvent } from '../types/agenda'
import { APPOINTMENT_TYPE_MAP, EVENT_TO_APPOINTMENT_TYPE } from '../types/agenda'

/** Preserve date-only values and null times, without synthesizing midnight. */
export function appointmentToCalendarEvent(appointment: AppointmentResponse): CalendarEvent {
  return {
    ...appointment,
    type: APPOINTMENT_TYPE_MAP[appointment.appointment_type],
    start_date: appointment.date,
    source: 'appointment',
  }
}

export function calendarEventToAppointment(event: Partial<CalendarEvent>) {
  const { start_date, type, source, end_date, ...rest } = event
  return {
    ...rest,
    ...(start_date !== undefined ? { date: start_date } : {}),
    ...(type && EVENT_TO_APPOINTMENT_TYPE[type]
      ? { appointment_type: EVENT_TO_APPOINTMENT_TYPE[type] }
      : {}),
  }
}
